import React from 'react';
import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { ArbitrationQueueRow } from './types';
import { decisionColor, formatMoney, scoreLabel } from './format';

type Props = {
  rows: ArbitrationQueueRow[];
  selectedId?: number | null;
  onSelect: (row: ArbitrationQueueRow) => void;
};

const ArbitrationQueuePanel: React.FC<Props> = ({ rows, selectedId, onSelect }) => (
  <Paper elevation={1} sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>Priority Arbitration Queue</Typography>
    <TableContainer sx={{ maxHeight: 640 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="right">Score</TableCell>
            <TableCell>Source</TableCell>
            <TableCell>Cost Center</TableCell>
            <TableCell>Description</TableCell>
            <TableCell align="right">Requested</TableCell>
            <TableCell align="right">Recommended</TableCell>
            <TableCell>Decision</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.rid} hover selected={row.rid === selectedId} sx={{ cursor: 'pointer' }} onClick={() => onSelect(row)}>
              <TableCell align="right">
                <Typography variant="body2" sx={{ fontWeight: 700 }}>{Number(row.scr || 0).toFixed(1)}</Typography>
                <Typography variant="caption" color="text.secondary">{scoreLabel(row.scr)}</Typography>
              </TableCell>
              <TableCell>{row.src}</TableCell>
              <TableCell>{row.ccc}</TableCell>
              <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{row.nam}</Typography>
                <Typography variant="caption" color="text.secondary">{row.dsc}</Typography>
              </TableCell>
              <TableCell align="right">{formatMoney(row.rqa)}</TableCell>
              <TableCell align="right">{formatMoney(row.rca)}</TableCell>
              <TableCell><Chip size="small" label={row.dcc || 'PENDING'} color={decisionColor(row.dcc)} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

export default ArbitrationQueuePanel;
